import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Paper,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";
import VN from "../components/VN";

const pricingData = [
  {
    id: "verified-caregiver",
    title: "Zweryfikowana Opiekunka",
    subtitle: "Pakiet rekomendowany na start",
    price: "149",
    currency: "zł",
    period: "jednorazowo",
    badge: "Rekomendowany",
    isFeatured: true,
    features: [
      "Sprawdzenie tożsamości i dokumentów potwierdzających kwalifikacje.",
      "Rozmowa z osobą weryfikującą doświadczenie i sposób postępowania w typowych sytuacjach opiekuńczych.",
      "Oznaczenie profilu informacją o pomyślnej weryfikacji i wyróżnienie w wynikach wyszukiwania.",
    ],
    //buttonText: "Wybierz pakiet i zweryfikuj profil",
    buttonVariant: "contained",
  },
];

const Cennik = () => {
  return (
    <>
      <VN />
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          px: 2,
          backgroundColor: "grey.50",
          minHeight: "80vh",
        }}
      >
        <Container maxWidth="lg">
          {/* Sekcja Nagłówkowa */}
          <Box textAlign="center" mb={{ xs: 5, md: 8 }}>
            <Chip
              icon={<VerifiedUserRoundedIcon />}
              label="Bezpieczeństwo i Zaufanie"
              color="primary"
              variant="outlined"
              sx={{ mb: 2, fontWeight: 600 }}
            />
            <Typography
              variant="h3"
              component="h1"
              gutterBottom
              sx={{ fontWeight: 700, color: "text.primary" }}
            >
              Cennik weryfikacji opiekunki
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{ maxWidth: 600, mx: "auto", fontWeight: 400 }}
            >
              Inwestuj w wiarygodność swojego profilu na platformie
              twojaopiekunka.pl i zyskaj zaufanie rodzin szukających
              profesjonalnej opieki.
            </Typography>
          </Box>

          {/* Karty Cennika */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
              flexWrap: "wrap",
              gap: 4,
            }}
          >
            {pricingData.map((plan) => (
              <Card
                key={plan.id}
                component={Paper}
                elevation={plan.isFeatured ? 8 : 2}
                sx={{
                  maxWidth: 420,
                  width: "100%",
                  borderRadius: 4,
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  border: plan.isFeatured ? "2px solid" : "1px solid",
                  borderColor: plan.isFeatured ? "primary.main" : "divider",
                  transition:
                    "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 12,
                  },
                }}
              >
                {/* Badge Rekomendowany */}

                <CardContent sx={{ p: 4, flexGrow: 1 }}>
                  <Typography
                    variant="h5"
                    component="h2"
                    textAlign="center"
                    sx={{ fontWeight: 700, mt: plan.badge ? 1 : 0 }}
                  >
                    {plan.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    textAlign="center"
                    sx={{ mb: 3 }}
                  >
                    {plan.subtitle}
                  </Typography>

                  {/* Sekcja Ceny */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "baseline",
                      mb: 1,
                    }}
                  >
                    <Typography
                      variant="h2"
                      component="span"
                      sx={{ fontWeight: 800, color: "primary.main" }}
                    >
                      {plan.price}
                    </Typography>
                    <Typography
                      variant="h5"
                      component="span"
                      sx={{ fontWeight: 700, ml: 0.5, color: "text.primary" }}
                    >
                      {plan.currency}
                    </Typography>
                  </Box>

                  <Typography
                    variant="caption"
                    display="block"
                    textAlign="center"
                    color="text.secondary"
                    sx={{ mb: 3, textTransform: "uppercase", letterSpacing: 1 }}
                  >
                    {plan.period}
                  </Typography>

                  {/* Lista Cech / Opis pakietu */}
                  <List disablePadding>
                    {plan.features.map((feature, idx) => (
                      <ListItem
                        key={idx}
                        disableGutters
                        sx={{ py: 1, alignItems: "flex-start" }}
                      >
                        <ListItemIcon sx={{ minWidth: 36, mt: 0.5 }}>
                          <CheckCircleRoundedIcon
                            color="primary"
                            fontSize="small"
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={feature}
                          primaryTypographyProps={{
                            variant: "body2",
                            color: "text.primary",
                            lineHeight: 1.5,
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>

                {/* Przycisk Akcji */}
                {/*
                <CardActions sx={{ p: 4, pt: 0 }}>
                  <Button
                    fullWidth
                    size="large"
                    variant={plan.buttonVariant}
                    color="primary"
                    onClick={() => handleSelectPackage(plan.id)}
                    sx={{
                      py: 1.5,
                      borderRadius: 2,
                      fontWeight: 700,
                      textTransform: "none",
                      fontSize: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </Button>
                </CardActions>
                */}
              </Card>
            ))}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Cennik;
